import { render, staticRenderFns } from "./PurchaseNgEdit.vue?vue&type=template&id=269703b4&"
import script from "./PurchaseNgEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseNgEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports